import * as tools from "./utils/tools";
import * as operationPosition from "./utils/operationPosition";
import * as operations from "./utils/operations";
import * as generator from "./utils/generator";
import * as constants from "./utils/constants";
import * as createjs from "createjs-module";

/**
 * ・タッチデバイスへの対応
 * ・描画更新処理
 * @param  {} stage
 */
export const commonProcessing = (stage) => {
  //タッチデバイスに対応させる（共通処理）
  if (createjs.Touch.isSupported()) {
    createjs.Touch.enable(stage);
  }

  const handleTick = () => {
    stage.update();

    // オブジェクト数表示の更新
    // ベースイラストが含まれているので1減らす
    if (stage.getChildByName("displayObjectsContainer")) {
      $(".item-counter span").text(
        (stage.getChildByName("displayObjectsContainer").numChildren - 1)
          .toString()
          .padStart(3, "0")
      );
    }
  };

  // 時間経過にしたがって更新する(共通処理)
  createjs.Ticker.addEventListener("tick", handleTick);
};

/**
 * ・userAgentの判定をする関数（仕様が固まり次第固有の処理を
 * 仕様が
 * @param  {} stage
 */
export const judgeUserAgent = () => {
  const userAgent = navigator.userAgent;
  if (
    userAgent.indexOf("iPhone") > 0 ||
    (userAgent.indexOf("Android") > 0 && userAgent.indexOf("Mobile") > 0)
  ) {
    // do notthing
  } else if (
    userAgent.indexOf("iPad") > 0 ||
    userAgent.indexOf("Android") > 0
  ) {
    // タブレット用コード
  } else {
    // PC用コード
  }
  //console.log(userAgent);
};

/**
 * decoDataListをJSON化して出力
 * @param  {} stage
 */
export const getMaterialDataList = (stage) => {
  const decoDataList = [];

  const displayObjectsContainer = stage.getChildByName(
    "displayObjectsContainer"
  );
  for (const displayObject of displayObjectsContainer.children) {
    // decoDataがなければベースイラストなので無視
    if (displayObject.decoData === undefined) {
      continue;
    }

    const decoData = tools.getMaterialBaseData(
      displayObject,
      displayObjectsContainer
    );

    // 存在しないプロパティは勝手にJSON化からは無視されるのでとりあえず全部ある想定でつっこむ
    decoData["decoData"] = {};
    Object.assign(decoData["decoData"], displayObject.decoData);
    // if (decoData.decoData.src) {
    //   delete decoData.decoData.src;
    // }
    decoDataList.push(decoData);
  }
  //return JSON.stringify(decoDataList);
  return decoDataList;
};

/**
 * すべてのdeco情報を確認してcopyrightを表示すべきかどうかを取得
 * @param  {} stage
 */
export const getCopyrightType = (stage) => {
  const displayObjectsContainer = stage.getChildByName(
    "displayObjectsContainer"
  );
  for (const displayObject of displayObjectsContainer.children) {
    // decoDataがなければベースイラストなので無視
    if (displayObject.decoData === undefined) {
      continue;
    }

    // コピーライトが必要な作成素材以外は無視
    //if (displayObject.decoData.type != constants.decoType.needCopyrightSomething) {
    //   continue;
    //}

    // const deco_something_master = [];
    // const something_master = [];

    // const decoId = displayObject.decoData.decoId;
    // const uniqueId = deco_something_master[decoId]["unique_id"];
    // const copyrightType = something_master[uniqueId]["copyright_type"];
    // if (copyrightType != 0) {
    //   return true;
    // }
  }
  return false;
};

export const loadSaveDataWithEvent = (stage, saveData) => {
  loadSaveData(stage, saveData, true);
};

export const loadSaveDataWithoutEvent = (stage, saveData) => {
  loadSaveData(stage, saveData, false);
};

/**
 * save_dataをロード
 * @param  {} stage
 * @param  {} saveData
 */
const loadSaveData = (stage, saveData, needEvent = false) => {
  if (!saveData) {
    return;
  }
  // z-indexで比較
  saveData.sort((a, b) => {
    return a.z - b.z;
  });
  saveData.forEach((property) => {
    if (needEvent) {
      createMaterialWithEvent(stage, property);
    } else {
      createMaterialWithoutEvent(stage, property);
    }
  });
  return;
};

const createMaterialWithEvent = (stage, saveProperty) => {
  createMaterial(stage, saveProperty, true);
};

const createMaterialWithoutEvent = (stage, saveProperty) => {
  createMaterial(stage, saveProperty, false);
};

const createMaterial = (stage, saveProperty, needEvent = false) => {
  const createMaterialCallback = (stage, displayObject) => {
    alignDisplayObject(
      displayObject,
      saveProperty.x,
      saveProperty.y,
      saveProperty.scale,
      saveProperty.rotation
    );
    if (needEvent) {
      operations.addDisplayObjectEvent(stage, displayObject);
    }
  };
  generator.createMaterial(stage, saveProperty, createMaterialCallback);
};

const alignDisplayObject = (displayObject, x, y, scale, rotation) => {
  displayObject.scaleX = displayObject.scaleY = scale;
  displayObject.rotation = rotation;
  displayObject.x = x;
  displayObject.y = y;
};

/**
 * bitmapに関する関数群 ====================================================================================
 */

/**
 * 投稿用フレームの作成
 * @param  {} frameContainer
 * @param  {} src // preloadしたframe画像
 * @param  {} childs // フレームに載せる子要素の配列
 * @param  {} writeText フレームに載せる追加文言 TODO 分割したい
 */
export const createFrame = (frameContainer, src, childs, writeText = "") => {
  // 投稿用のフレーム
  const frame = new createjs.Bitmap(src);
  frameContainer.addChild(frame);

  const inputWriteText = new createjs.Text(
    writeText,
    "28px keifont",
    "#000000"
  );
  inputWriteText.x = 30;
  inputWriteText.y = 800;
  frameContainer.addChild(inputWriteText);

  const today = new Date();
  let text =
    "" +
    today.getFullYear() +
    "." +
    (today.getMonth() + 1) +
    "." +
    today.getDate();
  /* Twitterに紐付かないので一旦コメントアウト
  //text += " @" + $("#form_twitter_screen_name").val();
  //text += " #my_kamon #マイ家紋"; // FIXME どこかに切り出したい
  */
  text += " マイ家紋";
  text += " https://kamon.spookies.co.jp/";

  const inputText = new createjs.Text(text, "16px keifont", "#000000");
  inputText.x = 30;
  inputText.y = 960;
  frameContainer.addChild(inputText);

  childs.forEach((child) => {
    frameContainer.addChild(child);
  });
};

/**
 * イラスト選択画面で選択された背景画像をImageTrimCanvasにセットする関数
 * @param  {} stage
 * @param  {} bgImage // pathではなくimg要素
 */
export const setBgImage = (stage, bgImage) => {
  const shape = new createjs.Shape();
  shape.graphics
    .beginBitmapFill(bgImage, "repeat")
    .drawRect(0, 0, stage.canvas.width, stage.canvas.height);
  stage.addChildAt(shape, 0);

  return shape;
};

/**
 * イラスト選択画面で選択された画像をImageTrimCanvasにセットする関数
 * @param  {} stage
 * @param  {} imageSrc
 */
export const setImageTrimCanvas = (stage, imageSrc) => {
  const selectedBitmap = new createjs.Bitmap(imageSrc);

  selectedBitmap.image.onload = () => {
    let dragPointX;
    let dragPointY;

    selectedBitmap.handleDown = (event) => {
      dragPointX = stage.mouseX - selectedBitmap.x;
      dragPointY = stage.mouseY - selectedBitmap.y;
    };

    selectedBitmap.handleMove = (event) => {
      selectedBitmap.x = stage.mouseX - dragPointX;
      selectedBitmap.y = stage.mouseY - dragPointY;
      // 拡大状態でも画面外には行かないようにする
      limitPosition(stage, selectedBitmap);
    };
    selectedBitmap.addEventListener("mousedown", selectedBitmap.handleDown);
    selectedBitmap.addEventListener("pressmove", selectedBitmap.handleMove);

    // 画像のanchorを中心に変更
    selectedBitmap.regX = selectedBitmap.getBounds().width / 2;
    selectedBitmap.regY = selectedBitmap.getBounds().height / 2;

    // 選択された画像はマージンを考慮して中央に配置する
    const initPosition = {
      X: stage.canvas.width / 2,
      Y: constants.trimPageCanvasVisibleHeight / 2 + constants.trimPageMargin,
    };
    operationPosition.setPositionDesignation(selectedBitmap, initPosition);
    stage.addChild(selectedBitmap);

    // 拡縮時のイベント登録
    // 拡縮で画面外に行ってしまうことがあるので調整用functionも渡す
    tools.createScalingSlider(stage, selectedBitmap, limitPosition);
  };

  const limitPosition = (stage, selectedBitmap) => {
    const minX = -(selectedBitmap.getTransformedBounds().width / 2) + 1;
    const maxX =
      stage.canvas.width + selectedBitmap.getTransformedBounds().width / 2 - 1;
    selectedBitmap.x = Math.max(Math.min(selectedBitmap.x, maxX), minX);
    // 直値（trimming-areaのbottom位置）
    const minY =
      -(selectedBitmap.getTransformedBounds().height / 2) +
      constants.trimPageMargin +
      1;
    const maxY =
      750 +
      selectedBitmap.getTransformedBounds().height / 2 +
      constants.trimPageMargin -
      1;
    selectedBitmap.y = Math.max(Math.min(selectedBitmap.y, maxY), minY);
  };

  // ピンチイン・ピンチアウトのイベントを登録
  operations.addDisplayObjectPinchEvent(
    stage,
    selectedBitmap,
    (targetDisplayObject, targetScale) => {
      tools.setTrimScale(
        stage,
        targetDisplayObject,
        targetScale,
        limitPosition
      );
    }
  );

  return selectedBitmap;
};

/**
 * トリミングされた画像を背面に設置する関数
 * (背景画像はドラッグで動かすことはできない。押下時にボタン群を削除)
 * @param  {} stage
 * @param  {} foundationProperty
 */
export const createFoundationBitmap = (stage, foundationProperty) => {
  const oldFoundationBitmap = stage.getChildByName("foundation");
  if (oldFoundationBitmap) {
    stage.removeChild(oldFoundationBitmap);
  }
  const displayObjectsContainer = stage.getChildByName(
    "displayObjectsContainer"
  ); // TODO ここは、名前付きの必要があるか！？依存度が高くて、流用できない
  const foundationBitmap = new createjs.Bitmap(foundationProperty.src);
  foundationBitmap.name = "foundation";

  foundationBitmap.image.onload = () => {
    displayObjectsContainer.addChild(foundationBitmap);

    foundationBitmap.scaleX = foundationBitmap.scaleY =
      foundationProperty.scale;
    foundationBitmap.x = -foundationProperty.x * foundationProperty.scale;
    foundationBitmap.y = -foundationProperty.y * foundationProperty.scale;

    foundationBitmap.handleDown = (event) => {
      // フォーカスが当たっているのを元に戻す処理
      operations.focusOff();
    };

    // イベント登録
    foundationBitmap.addEventListener("mousedown", foundationBitmap.handleDown);
    displayObjectsContainer.addChild(foundationBitmap);

    // 背面にセットするためにインデックスを０に設定する
    displayObjectsContainer.setChildIndex(foundationBitmap, 0);
  };
};

/**
 * 作成素材を設置する関数
 * @param  {} stage
 * @param  {} decoData
 */
export const createMaterialAndSetOperations = (stage, decoData) => {
  const createProperty = {
    decoData: decoData,
  };
  generator.createMaterial(
    stage,
    createProperty,
    operations.addDisplayObjectEvent
  );
};

/**
 * 作成素材のプレビュー表示をする関数
 * @param  {} stage
 * @param  {} decoData
 */
export const createPreviewMaterial = (stage, decoData) => {
  // previewを一旦削除
  const previewContainer = stage.getChildByName("previewContainer");
  previewContainer.removeAllChildren();

  const createProperty = {
    decoData: decoData,
    targetContainer: "previewContainer",
  };
  return generator.createMaterial(stage, createProperty);
};

/**
 * 色を変えられる作成素材配置時の色変更ツールボックスを表示する関数
 * @param  {} targetDisplayObject
 */
export const displayChangeMonoColorToolboxOnCreate = (targetDisplayObject) => {
  const changeMonoColorToolbox = $(".toolbox--change-material-color");
  operations.displayChangeColorToolbox(
    changeMonoColorToolbox,
    "000000",
    (toolbox, unsharpedColor) => {
      operations.changeMaterialColor(
        toolbox,
        unsharpedColor,
        targetDisplayObject
      );
    },
    null
  );
};

/**
 * 作成素材の数が最大配置数を超えているか判定する関数
 * @param  {} stage
 */
export const isOverMaterialMaxNum = (stage) => {
  // 120個を超えたら置けない
  // ベースイラストが含まれていることに注意する
  const displayObjectsContainer = stage.getChildByName(
    "displayObjectsContainer"
  );
  return displayObjectsContainer.numChildren - 1 >= constants.decoMaxNum;
};

/**
 * 作成素材を設置する関数
 * @param  {} stage
 */
export const fixDisplayObject = (stage) => {
  const previewContainer = stage.getChildByName("previewContainer");
  const displayObjectsContainer = stage.getChildByName(
    "displayObjectsContainer"
  );
  if (isOverMaterialMaxNum(stage)) {
    return;
  }
  const remainCreatableNum =
    constants.decoMaxNum - (displayObjectsContainer.numChildren - 1);
  previewContainer.children
    .slice(0, remainCreatableNum)
    .forEach((displayObject) => {
      displayObjectsContainer.addChild(displayObject);
      operations.addDisplayObjectEvent(stage, displayObject);
    });
  // プレビューの削除
  previewContainer.removeAllChildren();
};

/**
 * 次の作成素材を選択する関数
 */
export const focusChange = () => {
  operations.focusChange();
};

/**
 * END======================================================================================================================
 */
